export function scrollToLinks() {
	const links = document.querySelectorAll('.c-case-study__buttons .button, .contact-cta-button');

	for (const link of links) {
		link.addEventListener('click', clickHandler);
	}

	function clickHandler(e) {
		e.preventDefault();
		const href = this.getAttribute('href');
		const offsetTop = document.querySelector(href).offsetTop;

		scroll({
			top: offsetTop,
			behavior: 'smooth',
		});
	}
}
